/**
 * Model representing a master user
 */
export class UsuarioMaster {
  constructor(
    public readonly codLogin: number,
    public readonly idMaster: string,
    public readonly dscLogin: string,
    public readonly dscNome: string,
    public readonly dscEmail: string,
    public readonly codPerfil: number,
    public readonly indAtivo: boolean,
    public readonly numDddFone: string = '',
    public readonly numFone: string = '',
    public readonly numRg?: string,
    public readonly dscIdentificacao?: string,
    public readonly datNascimento?: string,
    public readonly datExpedicaoRg?: string,
    public readonly dscExpedicaoRg?: string,
    public readonly descPerfil?: string,
    public readonly codEntidade?: number,
    public readonly dscLoginEntidade?: string
  ) {}

  static fromJson(json: any): UsuarioMaster {
    return new UsuarioMaster(
      json.codLogin,
      json.idMaster || '',
      json.dscLogin || '',
      json.dscNome || '',
      json.dscEmail || '',
      json.codPerfil || 0,
      json.indAtivo ?? true,
      json.numDddFone || '',
      json.numFone || '',
      json.numRg,
      json.dscIdentificacao,
      json.datNascimento,
      json.datExpedicaoRg,
      json.dscExpedicaoRg,
      json.descPerfil,
      json.codEntidade,
      json.dscLoginEntidade
    );
  }

  get telefoneCompleto(): string {
    return `${this.numDddFone} ${this.numFone}`.trim();
  }

  toJson(): any {
    return {
      codLogin: this.codLogin,
      idMaster: this.idMaster,
      dscLogin: this.dscLogin,
      dscNome: this.dscNome,
      dscEmail: this.dscEmail,
      codPerfil: this.codPerfil,
      indAtivo: this.indAtivo,
      numDddFone: this.numDddFone,
      numFone: this.numFone,
      numRg: this.numRg,
      dscIdentificacao: this.dscIdentificacao,
      datNascimento: this.datNascimento,
      datExpedicaoRg: this.datExpedicaoRg,
      dscExpedicaoRg: this.dscExpedicaoRg,
      descPerfil: this.descPerfil,
      codEntidade: this.codEntidade,
      dscLoginEntidade: this.dscLoginEntidade,
    };
  }
}

